import { useNavigate } from '@tanstack/react-router';
import { useCompanies } from '../../hooks/useCompanies';
import {
  CONSOLIDATED,
  setActiveCompanyId,
  useActiveSelection,
} from '../../stores/useCompanyStore';

export function CompanySwitcher() {
  const selection = useActiveSelection();
  const navigate = useNavigate();
  const { data: companies = [], isLoading } = useCompanies(true);

  if (isLoading) {
    return <span style={{ color: 'var(--text-faint)', fontSize: 14 }}>Loading…</span>;
  }
  if (companies.length === 0) {
    return <span style={{ color: 'var(--tag-warn-fg)', fontSize: 14 }}>No companies yet</span>;
  }

  const activeCompanies = companies.filter((c) => c.isActive);
  const archivedCompanies = companies.filter((c) => !c.isActive);
  const consolidatedCount = activeCompanies.filter((c) => c.includeInConsolidated).length;

  return (
    <select
      id="company-switcher"
      name="company-switcher"
      aria-label="Active company"
      value={selection ?? ''}
      onChange={(e) => {
        const value = e.target.value || null;
        setActiveCompanyId(value);
        // Consolidated is a reporting view — jump straight to the reports.
        if (value === CONSOLIDATED) void navigate({ to: '/reports' });
      }}
      style={{
        padding: '6px 10px',
        borderRadius: 6,
        border: '1px solid var(--border-input)',
        background: 'var(--bg-surface)',
        color: 'var(--text-default)',
        font: 'inherit',
        minWidth: 200,
      }}
    >
      <option value="">— select company —</option>
      <option value={CONSOLIDATED}>★ Consolidated ({consolidatedCount})</option>
      {activeCompanies.map((c) => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
      {archivedCompanies.length > 0 && (
        <optgroup label="Archived">
          {archivedCompanies.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name} (archived)
            </option>
          ))}
        </optgroup>
      )}
    </select>
  );
}
